import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { BankTransactionResource } from "@exonn/js-sdk";

export const module: Module<BankTransactionResource> = {
  id: ResourceEnum.BankSepa,
  bigIcon: <i className="icon-20-sepa" />,
  smallIcon: <i className="icon-15-sepa" />,
  name: (t: TFunction) => t("moduleName.bank-sepa"),
  disableEdit: true,
  disableCreate: true,
  disableDelete: true,
};
